import axios, {AxiosResponse} from "axios";
import {OrderType} from "@/enums";

const PATH = "/v2/customers";

export interface CustomerOrder {
    id: string;
    name: string;
    orderType: OrderType;
    validFrom: string;
    validTo?: string;
    notes?: string;
}

export interface CustomerOrders {
    orders: Array<CustomerOrder>;
}

export interface CustomerOrderTeamLeader {
    id: string;
    firstName: string;
    lastName: string;
}

// An order with the work logged on it; without work, workStart and workEnd are missing and both counts are 0
export interface CustomerOrderSummary extends CustomerOrder {
    teamLeader?: CustomerOrderTeamLeader;
    workStart?: string;
    workEnd?: string;
    workedMinutes: number;
    employeeCount: number;
    positions?: number;
}

export interface CustomerOrderSummaries {
    orderSummaries: Array<CustomerOrderSummary>;
}

export default {
    // The customer's inventory orders whose first day lies on or after the given day, ascending by their first day
    findInventoryOrdersStartingFrom (customerId: string, startsFrom: string): Promise<AxiosResponse<CustomerOrders>> {
        return axios.get(`${PATH}/${customerId}/orders`, {params: {startsFrom, orderTypes: OrderType.INV}});
    },
    // The summaries of the customer's inventory orders whose first day lies before the given day, latest first
    findInventoryOrderSummariesStartingBefore (customerId: string, startsBefore: string):
        Promise<AxiosResponse<CustomerOrderSummaries>> {
        return axios.get(`${PATH}/${customerId}/order-summaries`,
            {params: {startsBefore, orderTypes: OrderType.INV, sort: "validFrom,desc"}});
    }
};
